import { Owlmoji } from '@readme/markdown-legacy';
import { Text, Transforms } from 'slate';

import type { Normalizer } from '@ui/MarkdownEditor/types';

import { type } from './shared';

// @todo: import from markdown
const regex = /(?<=^|\s):(?<name>\+1|[-\w]+):/g;

const parseShortcode: Normalizer =
  next =>
  // eslint-disable-next-line consistent-return
  (editor, [node, path]) => {
    if (!Text.isText(node)) return next();

    const match =
      'gemojiRegex' in editor.renderingLibrary
        ? editor.renderingLibrary.gemojiRegex.exec(node.text)
        : regex.exec(node.text);
    if (!match) return next();

    const { name } = match.groups as { name: string };
    if (Owlmoji.kind(name) !== 'gemoji') return next();

    const at = {
      anchor: {
        path,
        offset: match.index,
      },
      focus: { path, offset: match.index + match[0].length },
    };

    Transforms.insertNodes(
      editor,
      { name, type, value: Owlmoji.nameToEmoji[name], children: [{ text: '' }] },
      { at, select: true },
    );
  };

export default [parseShortcode];
